import React from "react"

import FieldsFactory from "../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../core/fields3/field-type"
import FieldFormElementView from "../../../../../core/fields3/render/form-elemnent-view"
import {FieldViewSize} from "../../../../../core/fields3/const"
import AddView from "../submenu/add-view/add-view"
import ProjectSession from "../../../../../core/model2/project/project-session";

const debug = false
// const debug = "CompactViewSelector"

type Props = {
    project     : ProjectSession
}

export default function CompactViewSelector(props:Props) {

    const onChangeView = (viewId:ID) => {
        const projectView = gd.projectViews.get(viewId)
        projectView && gd.goTo(projectView.url)
    }

    const views = gd.projectViews.models

    if (!gd.projectViews.currentView?.showInSubmenu && _.isEmpty(views)) {

        if (!props.project.acl.canAddView) return null

        return <AddView className="m-l-15" projectId={gd.projectViews.project.id}/>

    }

    const field = FieldsFactory.get({
        fieldId         : 'id',
        type            : FieldType.SELECT_VIEW,
        views           : views,
    })

    debug && console.log(debug, 'render', gd.projectViews.currentView)

    return (
        <FieldFormElementView className = "m-l-15"
                              size      = {FieldViewSize.SMALL}
                              field     = {field}
                              options   = {{size: 28}}
                              model     = {gd.projectViews.currentView}
                              onChange  = {onChangeView}/>
    )


}